module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAMAAAC7faEHAAAAZlBMVEUAAAAAOEAANj0AOTkAOD8AOD8AOD4AMz4AOEAANz8ANjkANz4AOD8AOT4AOUAAMzoANz8AOT8ANz4AOD8AOD4AOD4ANz4ANz4ANz4AOT8ANz4AOT8ANz4ANjsANzwANDoAAAAAOD906KTHAAAAIXRSTlMAUPsb2s53LezsCsLgLSwXmU316tvBsoi9mZR+cz0zLAWwGRuVAAAAwUlEQVQ4y+3Qyw6CMBCF4VMUtd5qQcC79v1f0tqctEZaZ+fKfzfhY8KAcpOpOyyRKjPnVoQCI5RYRyiwGXaEAgOhxBIssxOHI2Hp0koBcWP3yLC9f9C8wd7PNs8uWx2h8u9oUzohQlU5t5iXWIQSIzx7possQfd1G7t7WN6Wso28LVz6Zz9nyDG9wSiJJbcWGZ34bXQioxMZncjoJEZX1SFeavp61BAc4w8ZXKYr0MahfTGoDNMGMFYxg9BNfWYnwBN75ygXyP4xlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobile/bianji.png
// module id = mmxu
// module chunks = 1